"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarketingLeadForm;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _traffic = require("@site/pattern-library-utils/traffic");
var _base = require("@site/pattern-library-utils/base.functions");
var _useIdempotentImpression = _interopRequireDefault(require("@site/pattern-library-utils/hooks/useIdempotentImpression"));
var _useScriptInjector = _interopRequireWildcard(require("@site/pattern-library-utils/hooks/useScriptInjector"));
var _useLeadGenLoadingDetection = _interopRequireDefault(require("@site/pattern-library-utils/hooks/useLeadGenLoadingDetection"));
var _domains = require("@site/pattern-library-utils/domains");
var _cookies = require("@site/pattern-library-utils/cookies");
var _leadGenScript = require("@site/pattern-library-utils/lead-gen-script");
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _useErrorDetection = require("./use-error-detection");
var _skeleton = _interopRequireDefault(require("./skeleton"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * [@jpineda1]: Similar to "packages/pattern-library/src/elements/other/form-group/index.js"
 */
const FormWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FormWrapper",
  class: "pl-f16bvizs"
});
const EMBED_WRAPPER_ID = 'marketing-lead-form-wrapper';
const SCRIPT_ID = 'marketing-lead-form-script';
function useLoadApp({
  eid,
  productIntent,
  source,
  scriptStatus,
  trafficEventProps,
  wrapperRef
}) {
  (0, _react.useEffect)(() => {
    if (scriptStatus === _useScriptInjector.SCRIPT_STATUS.READY && wrapperRef?.current && (0, _leadGenScript.isLeadGenAvailable)()) {
      try {
        const difyLeadGenProps = {
          renderMode: 'embed',
          rootDomain: (0, _domains.getRootDomain)(),
          customerId: (0, _cookies.getCustomerId)(eid, trafficEventProps),
          market: (0, _base.getCookieValue)('market'),
          productIntent,
          source,
          sourceApp: _leadGenScript.SOURCE_APP
        };
        window.difyLeadGen.load(difyLeadGenProps, EMBED_WRAPPER_ID);
      } catch (e) {
        (0, _traffic.logEvent)({
          eid: `${eid}.load.error`,
          type: 'impression',
          properties: {
            source,
            sourceApp: _leadGenScript.SOURCE_APP
          }
        });
      }
    }
  }, [scriptStatus, wrapperRef]);
}
function MarketingLeadForm({
  eid,
  partial,
  productIntent,
  scriptUrl = '',
  source,
  ...errorProps
}) {
  const wrapperRef = (0, _react.useRef)(null);
  const trafficEventProps = {
    source,
    sourceApp: _leadGenScript.SOURCE_APP
  };
  const scriptStatus = (0, _useScriptInjector.default)({
    src: scriptUrl,
    id: SCRIPT_ID
  });
  const isFormLoading = (0, _useLeadGenLoadingDetection.default)(scriptStatus);
  const hasError = (0, _useErrorDetection.useErrorDetection)(scriptStatus);
  (0, _useIdempotentImpression.default)(`${eid}.impression`, trafficEventProps);
  useLoadApp({
    eid,
    productIntent,
    source,
    scriptStatus,
    trafficEventProps,
    wrapperRef
  });
  return /*#__PURE__*/_react.default.createElement(FormWrapper, {
    id: EMBED_WRAPPER_ID,
    ref: wrapperRef,
    "data-partial": partial
  }, isFormLoading && !hasError && /*#__PURE__*/_react.default.createElement(_skeleton.default, null), hasError && /*#__PURE__*/_react.default.createElement(_errorMessage.default, (0, _extends2.default)({
    eid: eid,
    source: source
  }, errorProps)));
}
MarketingLeadForm.propTypes = {
  buttonText: _propTypes.default.string,
  // Error button text
  eid: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  // Error title
  message: _propTypes.default.string.isRequired,
  // Error message
  image: _propTypes.default.shape({
    // Error image
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    url: _propTypes.default.string.isRequired,
    altText: _propTypes.default.string.isRequired
  }),
  partial: _propTypes.default.string,
  productIntent: _propTypes.default.string,
  scriptUrl: _propTypes.default.string.isRequired,
  source: _propTypes.default.string
};